
import HotDropdown from '~/components/Molecules/Dropdown/Dropdown.vue'

export default {
  name: 'NavigationDesktop',

  components: {
    HotDropdown,
  },

  props: {
    navigation: {
      type: Object,
      required: true,
    },
    isPT: {
      type: Boolean,
      default: false,
    },
    menuOpen: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isDropdownOpen: false,
    }
  },

  computed: {
    menuItemClasses() {
      return ['menu__item', { 'menu__item--pt': this.isPT }]
    },

    menuLinkClasses() {
      return ['link', 'link--menu', 'menu__link', { 'link--pt': this.isPT }]
    },

    signInSubmenuItems() {
      if (
        this.navigation.plattaform &&
        this.navigation.plattaform.signInSubMenu &&
        this.navigation.plattaform.signInSubMenu.submenu
      ) {
        return this.navigation.plattaform.signInSubMenu.submenu
      }

      return []
    },
  },

  methods: {
    handleDropdownToggle({ isActive }) {
      this.isDropdownOpen = isActive
    },

    handleMenuItemClick(navigationMenuItem) {
      const event = new CustomEvent('menu:item-click', {
        detail: { item: navigationMenuItem },
      })
      window.dispatchEvent(event)
    },

    closeMenu() {
      this.$emit('close-menu')
    },
  },
}
